<template>
  <GamingButtonValueIcon :value="gaming.level" description="Niveau">
    <template #icon>
      <img
        src="/images/icons/gaming-level.png"
        srcset="/images/icons/gaming-level@2x.png 2x"
      />
    </template>
  </GamingButtonValueIcon>
</template>
<script setup lang="ts">
const gaming = useGamingStore();
</script>
